import { render, staticRenderFns } from "./ErrorNotificationPopup.vue?vue&type=template&id=74ca375b&"
import script from "./ErrorNotificationPopup.vue?vue&type=script&lang=js&"
export * from "./ErrorNotificationPopup.vue?vue&type=script&lang=js&"
import style0 from "./ErrorNotificationPopup.vue?vue&type=style&index=0&id=74ca375b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports